function LinkedinIcon() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" rx="10" fill="#C4C4C4" />
      <g clipPath="url(#clip0_1621_28)">
        <path
          d="M4.16699 5.72278C4.16699 5.3474 4.29838 5.03771 4.56114 4.79373C4.8239 4.54973 5.16549 4.42773 5.58591 4.42773C5.99883 4.42773 6.3329 4.54785 6.58816 4.78809C6.85092 5.03584 6.98231 5.35866 6.98231 5.75656C6.98231 6.11692 6.85468 6.41722 6.59942 6.65746C6.33667 6.90521 5.99132 7.02909 5.56339 7.02909H5.55213C5.13921 7.02909 4.80513 6.90521 4.54988 6.65746C4.29462 6.40972 4.16699 6.09815 4.16699 5.72278ZM4.31339 15.5764V8.05386H6.81339V15.5764H4.31339ZM8.19852 15.5764H10.6985V11.3759C10.6985 11.1132 10.7286 10.9105 10.7886 10.7678C10.8937 10.5126 11.0533 10.2967 11.2672 10.1203C11.4812 9.94387 11.7496 9.85566 12.0724 9.85566C12.9132 9.85566 13.3337 10.4225 13.3337 11.5561V15.5764H15.8337V11.2633C15.8337 10.1522 15.5709 9.30949 15.0454 8.73517C14.5198 8.16084 13.8254 7.87368 12.962 7.87368C11.9936 7.87368 11.2391 8.29035 10.6985 9.12368V9.1462H10.6873L10.6985 9.12368V8.05386H8.19852C8.21353 8.2941 8.22105 9.04109 8.22105 10.2949C8.22105 11.5486 8.21353 13.3091 8.19852 15.5764Z"
          fill="#272B2F"
        />
      </g>
      <defs>
        <clipPath id="clip0_1621_28">
          <rect
            x="4.16699"
            y="4.16602"
            width="11.6667"
            height="11.6667"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default LinkedinIcon
